import React from "react";
import { Box, UIProvider } from "src/components/UI";

const ElectronicMoneyWrapper = (props: React.PropsWithChildren<{}>) => {
  const { children } = props;

  return (
    <UIProvider>
      <Box maxWidth={["100%", "1040px"]} margin="0 auto">
        {children}
      </Box>
    </UIProvider>
  );
};

export default ElectronicMoneyWrapper;
